import React from 'react'
import { graphql } from 'gatsby'
import { PageHelmet } from '../../../common/components'

const Topics = ({ data }) => {
  const categories = {}
  data?.allDatoCmsArticle?.edges?.forEach(({ node: article }) => {
    categories[article.category.category.id] = {
      title: `${article.category.category.title}`,
      slug: `${article.category.category.slug}`,
    }
  })

  return (
    <div className="container content">
      <PageHelmet title="Site Directory" />
      <h1 className="text-center">Site Directory</h1>
      {Object.keys(categories).map((category) => (
        <ul>
          <li>
            <label className="fw-bold">
              <a href={`/${categories[category]?.slug}`}>
                {categories[category]?.title}
              </a>
            </label>
            <ul>
              {data?.allDatoCmsSubcategory?.edges
                ?.filter(
                  ({ node }) =>
                    node?.category?.title === categories[category]?.title,
                )
                .sort(function (a, b) {
                  return a.node.title === b.node.title
                    ? 0
                    : a.node.title < b.node.title
                    ? -1
                    : 1
                })
                ?.map(({ node }) => (
                  <a href={`/${node?.category?.slug}/${node.slug}`}>
                    <li>{node?.title}</li>
                  </a>
                ))}
            </ul>
          </li>
        </ul>
      ))}
    </div>
  )
}

export default Topics

export const query = graphql`
  {
    allDatoCmsArticle {
      totalCount
      edges {
        node {
          id
          slug
          shortUrl
          category {
            id
            slug
            category {
              id
              slug
              title
            }
          }
        }
      }
    }
    allDatoCmsSubcategory {
      edges {
        node {
          id
          slug
          title
          body
          category {
            slug
            title
          }
        }
      }
    }
  }
`
